<div class="pedido-nao-liberado-card-info-cliente-inadimplente card card-warning">
    <div class="card-header">
        <p class="card-title mb-0">
            Cliente Inadimplente
        </p>
    </div>
    <ul class="list-group list-group-flush list-group-vertical">
        <li class="list-group-item">
            <span class="list-group-item-title">
                Motivo da Não Liberação
            </span>
            <span class="list-group-item-value">
                Este {{settings?.tipoVenda | pedidoTipoVendaSinonimo}} não foi liberado por que o cliente possui títulos vencidos e está inadimplente
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Não Liberado em
            </span>
            <span class="list-group-item-value">
                {{settings?.dataNaoLiberado | date: 'dd/MM/yyyy'}} às {{settings?.dataNaoLiberado | date: 'HH:mm'}}
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Quantidade de Títulos Vencidos
            </span>
            <span class="list-group-item-value">
                {{settings?.quantidadeTitulosVencidosNaoLiberado | decimalFormat: 1:0:0}}
            </span>            
        </li>
        <li class="list-group-item">
            <span class="list-group-item-title">
                Valor Total dos Títulos Vencidos
            </span>
            <span class="list-group-item-value">
                {{settings?.valorTitulosVencidosNaoLiberado | currencyFormat: 1:2:2}}
            </span>            
        </li>
    </ul>

    <div class="card-body">
        <p class="card-title mb-2" style="font-size: 12px; font-weight: 600;">Títulos Vencidos</p>
        <sgt-table [settings]="tableSettings">
            <tr header>
                <th class="text-right">Número ERP</th>
                <th class="text-center">Vencimento</th>
                <th class="text-right">Valor R$</th>
                <th class="text-right">Saldo R$</th>
            </tr>

            <ng-container body>
                <tr *ngFor="let titulo of settings?.titulosVencidosNaoLiberado; trackBy: trackByTituloId">
                    <td class="text-right">{{ titulo.numeroErp || '-' }}</td>
                    <td class="text-center">{{ (titulo.dataVencimento | date: 'dd/MM/yyyy') || '-' }}</td>
                    <td class="text-right">{{ titulo.valor | currencyFormat: 1:2:2 }}</td>
                    <td class="text-right">{{ titulo.valorSaldo | currencyFormat: 1:2:2 }}</td>
                </tr>
            </ng-container>

            <ng-container empty>
                <tr>
                    <td colspan="4" class="text-center text-muted py-4">Nenhum título vencido</td>
                </tr>
            </ng-container>
        </sgt-table>
    </div>
</div>